import React from 'react';
export function Specializations() {
  const specializations = [{
    title: 'Operationele Beveiliging',
    description: 'Gespecialiseerd in operationele beveiliging in complexe omgevingen zoals Schiphol.'
  }, {
    title: 'Teamcoördinatie',
    description: 'Ervaren in het aansturen van beveiligingsteams en het coördineren van operaties.'
  }, {
    title: 'Klantgericht Werken',
    description: 'Sterke achtergrond in klantcontact en dienstverlening uit jarenlange retail ervaring.'
  }, {
    title: 'IT-Ondersteuning',
    description: 'Expertise in Windows, Linux en kassasystemen voor technische beveiligingsoplossingen.'
  }, {
    title: 'Calamiteitenbeheersing',
    description: 'BHV gecertificeerd met ervaring in het hanteren van noodsituaties.'
  }, {
    title: 'Internationale Omgeving',
    description: 'Ervaring in internationale werkomgevingen met meertalige communicatie (NL, EN, TR).'
  }, {
    title: 'Personeelsplanning',
    description: 'Bekwaam in efficiënte planning en inzet van beveiligingspersoneel.'
  }];
  return <section id="services" className="py-16 md:py-20 border-b border-zinc-800" data-id="element-290">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-291">
        <h2 className="text-2xl md:text-3xl font-light mb-8 md:mb-10" data-id="element-292">
          Beveiligingsspecialisaties
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-293">
          {specializations.map((spec, index) => <div key={index} className="bg-zinc-900 p-6 rounded-none hover:bg-black transition-all border-t border-zinc-800 shadow-sm" data-id="element-294">
              <h3 className="text-lg md:text-xl font-medium mb-3 text-slate-300" data-id="element-295">
                {spec.title}
              </h3>
              <p className="text-zinc-400 text-sm md:text-base leading-relaxed" data-id="element-296">
                {spec.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}